import {FeatureAppLoader} from '@feature-hub/react';
import {pascalCase} from 'change-case';
import React, {useId} from 'react';

type FeatureAppProps<T = unknown> = {
  name: string;
  /**
   * Fetched stage from endpoint directory otherwise defaults to `dev`
   */
  envName?: string;
  /**
   * @default `/assets/feature-app/feature-app.js`
   */
  src?: string;
  /**
   * @default `/__app__/${name}/${stage}`
   */
  baseUrl?: string;
  config?: T;
  done?: () => void;
  /**
   * Unique identifier for the feature app.
   * @default `${name}-${env}-${random-value}`
   *
   */
  id?: string;
};

const DEFAULT_SRC = `/assets/feature-app/feature-app.js`;
/**
 * Loads an app from a remote endpoint.
 *
 * @example
 * ```tsx
 * <FeatureApp name="my-app" />
 * ```
 */
export const FeatureApp: React.FunctionComponent<FeatureAppProps> = ({
  config,
  done,
  envName,
  name,
  src = DEFAULT_SRC,
  id,
}) => {
  const featureAppId = useId();

  const env = envName ?? `dev`;

  return (
    <FeatureAppLoader
      featureAppId={id ?? `${name}-${env}-${featureAppId}`}
      featureAppName={pascalCase(name)}
      baseUrl={`/__app__/${name}/${env}`}
      src={src}
      config={config}
      done={done}
    />
  );
};
